var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "circle-check"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M18.5002 6.16659C11.6887 6.16659 6.16683 11.6884 6.16683 18.4999C6.16683 25.3114 11.6887 30.8333 18.5002 30.8333C25.3117 30.8333 30.8335 25.3114 30.8335 18.4999C30.8335 11.6884 25.3117 6.16659 18.5002 6.16659ZM3.0835 18.4999C3.0835 9.98553 9.98577 3.08325 18.5002 3.08325C27.0146 3.08325 33.9168 9.98553 33.9168 18.4999C33.9168 27.0143 27.0146 33.9166 18.5002 33.9166C9.98577 33.9166 3.0835 27.0143 3.0835 18.4999ZM25.6911 13.4935C26.3274 14.0592 26.3848 15.0336 25.8191 15.67L17.5969 24.92C17.3043 25.2491 16.885 25.4374 16.4446 25.4374C16.0042 25.4374 15.5849 25.2491 15.2924 24.92L11.1812 20.295C10.6156 19.6586 10.6729 18.6842 11.3093 18.1185C11.9456 17.5528 12.9201 17.6102 13.4858 18.2465L16.4446 21.5752L23.5146 13.6215C24.0802 12.9852 25.0547 12.9278 25.6911 13.4935Z",
    fill: "#140C0F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.63346cf8e971861098eab2b54e3eda5c.svg";
export { ForwardRef as ReactComponent };